import moment from "moment";
export const TimeConversion = (date, limit) => {

    if (date !== null) {
        if (limit !== null && limit !== undefined && limit !== 0) {
            return moment.utc(date).local().fromNow()
        }
        else if (limit === 0) {

            return moment.utc(date).local().format('MMM-DD-YYYY');
        }
        else {
            if (moment.duration(moment().diff(moment.utc(date).local())).days() > limit) {
                return moment.utc(date).local().format('MMM-DD-YYYY');
            }

        }
    }
    else {
        return "-"
    }
}